import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { SmallDropdown } from '@americanexpress/consumer-travel-base';
import { useReactlytics } from '@americanexpress/reactlytics';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { CLASS_TYPES, CLASS_TYPES_TRACKING } from '../../../constants/flightConstants';
import { getFlightClass } from '../../../selectors/filtersSelectors';
import { setFlightClassAction } from '../../../ducks/filtersDuck';
import themeContext from '../../../context/themeContext';
import { hasFlightClassDropdownRule } from '../../../constants/ruleConstants';
import { MODULE_NAME } from '../../../constants/packagesConstants';

const FlightClassDropdown = () => {
  const theme = useContext(themeContext);
  const { formatMessage } = useIntl();
  const { track } = useReactlytics();
  const dispatch = useDispatch();
  const flightClass = useSelector(getFlightClass);
  const hasFlightClassDropdown = useConditionalFeature(hasFlightClassDropdownRule);

  const handleChange = (newFlightClass) => {
    track({
      event: {
        element: CLASS_TYPES_TRACKING[newFlightClass],
        identifier: MODULE_NAME,
      },
    });
    dispatch(setFlightClassAction(newFlightClass));
  };

  if (!hasFlightClassDropdown) {
    return null;
  }

  return (
    <div className="col-lg-3 col-sm-6 col-xs-12 flex">
      <SmallDropdown
        ariaLabel={formatMessage({ id: 'flightClassDropdown.ariaLabel' })}
        id="flight-class-dropdown"
        theme={theme}
        value={flightClass}
        onChange={handleChange}
        options={[
          {
            label: formatMessage({ id: 'economy' }),
            value: CLASS_TYPES.ECONOMY,
          },
          {
            label: formatMessage({ id: 'premium_economy' }),
            value: CLASS_TYPES.PREMIUM_ECONOMY,
          },
          {
            label: formatMessage({ id: 'business_class' }),
            value: CLASS_TYPES.BUSINESS,
          },
          {
            label: formatMessage({ id: 'first_class' }),
            value: CLASS_TYPES.FIRST,
          },
        ]}
      />
    </div>
  );
};

export default FlightClassDropdown;
